import React from 'react';
import { connect } from 'react-redux';
import 'react-widgets/lib/less/react-widgets.less';
import { Edit as DictEdit, mapDispatchToProps } from '../Edit';
import { REF_NAME, REF_PATH, NAME } from './Const';
import { List as ImmutableList } from 'immutable';
import RequiredFormControl from '../../../form/RequiredFormControl.jsx';
import { MainComponentBox, FormGroupWValidation as FormGroup } from '@/util/util.jsx';
import {
  FormControl,
  Button,
} from '../../../form/FormControls.jsx';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import EditWarningRow from '@/component/dict/simple/EditWarningRow';

class Edit extends DictEdit {
  constructor() {
    super();
    this.setRefPath(REF_PATH);
    this.setRefName(REF_NAME);
    this.setName(NAME);
  }

  render() {
    let component;
    if (this.props.params.refId == 'new' || this.state.ref) {
      component = (<div>
        <form id="refForm" onSubmit={this.onSubmit}>
          <input
            className="hide" type="text" name="predefine"
            value={this.state.ref ? this.state.ref.get('predefine') : undefined} readOnly
          />
          <EditWarningRow />
          <MainComponentBox withBreadcrumb>
            <Row className={'reference-edit-panel'}>
              <Col xs={12} md={6} lg={6}>
                {this.getLabel()}
                <FormGroup id="name">
                  <ControlLabel style={{ height: 'auto' }}>Full name</ControlLabel>
                  <RequiredFormControl
                    component={FormControl}
                    name="name"
                    type="text"
                    defaultValue={this.state.ref ? this.state.ref.get('name') : undefined}
                  />
                </FormGroup>
                <FormGroup id="email">
                  <ControlLabel style={{ height: 'auto' }}>Email</ControlLabel>
                  <RequiredFormControl
                    component={FormControl}
                    name="email"
                    type="text"
                    defaultValue={this.state.ref ? this.state.ref.get('email') : undefined}
                  />
                </FormGroup>
                <Button
                  id="saveButton"
                  type="submit" bsStyle="primary" disabled={this.props.saving}
                >
                  {this.props.params.refId === 'new' ? 'Add' : 'Save'}
                </Button>
                <Button id="cancelButton" bsStyle="gray" onClick={this.onCancel}>Cancel</Button>
                <FormControl
                  name="id" type="id" style={{ display: 'none' }}
                  defaultValue={this.state.ref ? this.state.ref.get('id') : undefined}
                />
              </Col>
            </Row>
          </MainComponentBox>
        </form>
      </div>);
    } else {
      component = <div></div>;
    }
    return component;
  }
}

export default connect((state, props) =>
  ({ saving: state.getIn(['allaround', 'saving'], false),
    refObject: state.getIn(['references', 'simple', REF_PATH], new ImmutableList())
      .find(r => r.get('id') == props.params.refId) }),
mapDispatchToProps(REF_NAME, REF_PATH))(Edit);
